<script setup lang="ts"></script>

<template>
  <div class="mx-4 border-t border-gray-200 py-6 lg:mx-6">
    <slot />
  </div>
</template>

<style scoped></style>
